import React from 'react';

import clsx from 'clsx';

import PohCol from '@ui-kit/layout/Col';
import PohRow from '@ui-kit/layout/Row';

interface IPageHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  center?: React.ReactNode;
}

const PageHeader: React.FC<IPageHeaderProps> = ({
  title,
  subtitle,
  center,
  children,
  className,
}) => {
  let titleSize = 12;

  if (center) titleSize -= 3;
  if (children) titleSize -= 3;

  return (
    <header className={clsx('mb-3', className)}>
      <PohRow>
        <PohCol sm={titleSize} as="h3" className="m-0">
          {title}
        </PohCol>
        {center && (
          <PohCol
            sm={3}
            as="div"
            className="d-flex align-items-center justify-content-start justify-content-md-center"
          >
            {center}
          </PohCol>
        )}
        {children && (
          <PohCol sm={3} as="aside" className="d-flex justify-content-start justify-content-md-end">
            {children}
          </PohCol>
        )}
      </PohRow>
      {subtitle && (
        <>
          {typeof subtitle === 'string' ? (
            <p className="text-muted">
              <small>{subtitle}</small>
            </p>
          ) : (
            subtitle
          )}
        </>
      )}
    </header>
  );
};

export default PageHeader;
